import { Slider } from "@mui/material";
import { Mark } from "@mui/material/Slider/useSlider.types";
import React, { useEffect, useState } from "react";

interface UrineSubFieldProps {
  title: string;
  marks: Mark[];
  value?: string;
  onChange: (title: string, value: string) => void;
}

const UrineSubField = (props: UrineSubFieldProps) => {
  const { marks, title, value, onChange } = props;

  const [currentlyActiveMark, setCurrentlyActiveMark] = useState(0);
  useEffect(() => {
    switch (value) {
      case "-":
        setCurrentlyActiveMark(0);
        break;
      case "+":
        setCurrentlyActiveMark(1);
        break;
      case "++":
        setCurrentlyActiveMark(2);
        break;
      case "+++":
        setCurrentlyActiveMark(3);
        break;
      default:
        setCurrentlyActiveMark(0);
    }
  }, [value]);

  const handleSliderChange = (event: any, value: number | number[]) => {
    if (typeof value === "number") {
      const stringValue = value === 0 ? "-" : "+".repeat(value);
      onChange(title, stringValue);
    }
  };
  return (
    <div className="dui-urine-field-subfield">
      <div>{title}</div>
      <Slider
        aria-label="Restricted values"
        step={null}
        marks={marks}
        value={currentlyActiveMark}
        max={marks.length - 1}
        onChange={handleSliderChange}
      />
    </div>
  );
};

export default UrineSubField;
